import * as React from 'react';
import TFFButton from './TFFButton';
import { useIntl } from 'react-intl';
import TFFIconButton from './TFFIconButton';

interface TFFDialogProps {
  dialogId: string;
  header: React.ReactNode;
  children: React.ReactNode;
  isOpen: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
  confirmButtonText?: string;
  cancelButtonText?: string;
  closeButtonText?: string;
  confirmButton?: boolean;
  cancelButton?: boolean;
  closeButton?: boolean;
  confirmDisabled?: boolean;
  extraStyle?: React.CSSProperties;
  groupFooterButtons?: boolean;
}

export const TFFDialog: React.FC<TFFDialogProps> = ({
  dialogId,
  header,
  children,
  isOpen,
  onConfirm,
  onCancel,
  confirmButtonText,
  cancelButtonText,
  closeButtonText,
  confirmButton,
  cancelButton,
  closeButton,
  confirmDisabled,
  extraStyle,
  groupFooterButtons,
}) => {
  const intl = useIntl();

  React.useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = ''; // arrow function ensures that the overflow style is always reset appropriately
    };
  }, [isOpen]);

  const handleClose = () => {
    onCancel?.();
  };

  const handleConfirmation = () => {
    onConfirm?.();
  };

  return (
    <>
      <div
        aria-hidden="true"
        className="dialog-backdrop"
        id={`${dialogId}-backdrop`}
        onClick={handleClose}
        style={{ display: `${isOpen ? 'block' : ''}` }}
      ></div>
      <dialog className="dialog base js" id={dialogId} {...{ open: isOpen }} style={extraStyle}>
        <div className="modal tff-dialog">
          <header className="header">
            <span className="title">{header}</span>
            <span className="control">
              <TFFIconButton label={'Close button'} iconName={'cross'} handleClick={handleClose} />
            </span>
          </header>
          <section className="main">{children}</section>
          <menu className="footer tff-flex-space-between">
            {closeButton && (
              <TFFButton
                buttonText={closeButtonText || intl.formatMessage({ id: 'global.close' })}
                variant="secondary"
                handleClick={handleClose}
              />
            )}
            {cancelButton && !groupFooterButtons && (
              <TFFButton
                buttonText={cancelButtonText || intl.formatMessage({ id: 'global.cancel' })}
                handleClick={handleClose}
                outline
              />
            )}
            <div style={{ display: 'flex', gap: '8px', marginLeft: 'auto' }}>
              {cancelButton && groupFooterButtons && (
                <TFFButton
                  buttonText={cancelButtonText || intl.formatMessage({ id: 'global.cancel' })}
                  handleClick={handleClose}
                  outline
                />
              )}
              {confirmButton && (
                <TFFButton
                  buttonText={confirmButtonText || intl.formatMessage({ id: 'global.confirm' })}
                  handleClick={handleConfirmation}
                  disabled={confirmDisabled}
                />
              )}
            </div>
          </menu>
        </div>
      </dialog>
    </>
  );
};

export default TFFDialog;
